export const ACCOUNTS_PATH = 'accounts';
export const ACCOUNT_PATH = 'account';
export const TENANTS_PATH = 'tenants';
export const TENANT_PATH = 'tenant';
export const BOOKINGS_PATH = 'bookings';
export const BOOKING_PATH = 'booking';
export const CONTRACT_PATH = 'contract';
export const CONTRACTS_PATH = 'contracts';
export const TRANSACTIONS_PATH = 'transactions';
export const OVERVIEW_PATH = 'overview';

export const WELCOME_PATH = 'welcome';
